import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { toast } from 'sonner';
import { delay } from '../LitSessionContext/useLitAuth';
import useAppDetails from './useAppDetails';
export default function useInitRouterPath() {
  const {
    setIsNativeApp,
    setIsAppleNativeApp,
    setIsGoogleNativeApp,
    setReferralUrlCode
  } = useAppDetails();
  const router = useRouter();
  const [toastMessage, setToastMessage] = useState(null);
  useEffect(() => {
    var _a;
    async function replaceUrl(urlParams) {
      await delay(1000);
      urlParams.delete('message');
      urlParams.delete('removePWA');
      urlParams.delete('disableRef');
      urlParams.delete('code');
      const newUrl = `${window.location.pathname}${(urlParams === null || urlParams === void 0 ? void 0 : urlParams.toString()) ? `?${urlParams === null || urlParams === void 0 ? void 0 : urlParams.toString()}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const message = urlParams.get('message');
    const removePWA = urlParams.get('removePWA');
    const code = urlParams.get('code');
    if (removePWA) {
      setIsNativeApp(true);
      localStorage.setItem('removePWA', 'true');
      const onIPhone = (_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.includes('iPhone');
      if (onIPhone) {
        setIsAppleNativeApp(true);
      } else {
        setIsGoogleNativeApp(true);
      }
    }
    if (code) {
      setReferralUrlCode(code);
    }
    if (message || removePWA || code) {
      message && setToastMessage(message);
      replaceUrl(urlParams);
    }
  }, [router]);
  useEffect(() => {
    if (toastMessage) {
      toast(toastMessage, {
        duration: 5000
      });
    }
  }, [toastMessage]);
}